module.exports = __webpack_public_path__ + "img/intrusion-systemimg-1.bd00b316.png";